module.exports = __webpack_public_path__ + "images/icons/ic-signature-48-9be942e63802928c330db33c10a5e209.png";